import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    text: String,
    successTitle: { type: String, default: "Copied" },
    successBody: { type: String, default: "Link copied" },
    errorTitle: { type: String, default: "Copy failed" },
    errorBody: { type: String, default: "Could not copy link" }
  }

  async copy(event) {
    event.preventDefault()
    if (!this.hasTextValue || this.textValue.length === 0) return

    try {
      await navigator.clipboard.writeText(this.textValue)
      this.notify(this.successTitleValue, this.successBodyValue)
    } catch (_error) {
      this.notify(this.errorTitleValue, this.errorBodyValue)
    }
  }

  notify(title, body) {
    window.dispatchEvent(new CustomEvent("notifications:received", { detail: { title, body } }))
  }
}
